const PATTERNS: { type: string; regex: RegExp }[] = [
  { type: "mawb", regex: /^[0-9]{3}-[0-9]{8,10}$/i },
  { type: "container_no", regex: /^[A-Za-z]{4}\d{7}$/i },
  { type: "rail_car", regex: /^[A-Za-z]{4}\d{7}$/i },
  { type: "mbol", regex: /^[0-9]{7,10}$/i },
];

const PARTIAL_PATTERNS: Record<string, RegExp> = {
  mawb: /^[0-9]{1,3}(-[0-9]{0,10})?$/,
  mbol: /^[0-9]{1,10}$/,
  container_no: /^[A-Za-z]{0,4}\d{0,7}$/i,
  rail_car: /^[A-Za-z]{0,4}\d{0,7}$/i,
};

export function shouldRedetectTrackingType(reference: string, manuallySelectedType: string): boolean {
  const trimmed = reference.trim();
  if (!trimmed) return false;

  const partialPattern = PARTIAL_PATTERNS[manuallySelectedType];
  if (!partialPattern) return false;

  return !partialPattern.test(trimmed);
}

function isPatternAllowed(type: string, allowedTypeValues: string[]): boolean {
  if (!allowedTypeValues.includes(type)) return false;
  if (type === "rail_car" && allowedTypeValues.includes("container_no")) return false;
  return true;
}

export default function detectTrackingType(reference: string, allowedTypeValues: string[]): string {
  const trimmed = reference.trim();
  if (!trimmed) return "primary";

  const matchedType = PATTERNS.find(
    ({ type, regex }) => isPatternAllowed(type, allowedTypeValues) && regex.test(trimmed),
  )?.type;

  if (matchedType) return matchedType;

  return allowedTypeValues.includes("primary") ? "primary" : (allowedTypeValues[0] ?? "primary");
}
